import { render } from "./AdminHomeView.vue?vue&type=template&id=4781bd20"
import script from "./AdminHomeView.vue?vue&type=script&lang=js"
export * from "./AdminHomeView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__